/**
 * Body editor for the appendstruct step: target container, the source
 * whose shape is copied, and the optional alias for the appended sub-root.
 */
import React from "react"
import { QueryBuilderStore } from "stores/queryBuilderStore"
import { AppendStructStep } from "types/queryBuilder.types"
import SingleFieldSlot from "../SingleFieldSlot.component"
import { StepBodyProps } from "./stepBodyProps"

export interface AppendStructStepBodyProps
  extends StepBodyProps<AppendStructStep> {
  renameStep: QueryBuilderStore["renameTransformStep"]
  setAppendStructSource: QueryBuilderStore["setAppendStructSource"]
  setAppendStructAlias: QueryBuilderStore["setAppendStructAlias"]
}

const AppendStructStepBody: React.FC<AppendStructStepBodyProps> = ({
  step,
  renameStep,
  setAppendStructSource,
  setAppendStructAlias,
}) => (
  <>
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">Target:</span>
      <SingleFieldSlot
        value={step.target}
        onChange={(v) => renameStep(step.id, v)}
        placeholder="Drag (or type) the container — must already exist"
      />
    </div>
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">Copy shape of:</span>
      <SingleFieldSlot
        value={step.source}
        onChange={(v) => setAppendStructSource(step.id, v)}
        placeholder="Drag the source whose structure is copied"
      />
    </div>
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">Alias (optional):</span>
      <input
        className="qc-recodes__name qc-mono"
        type="text"
        value={step.alias}
        onChange={(e) => setAppendStructAlias(step.id, e.target.value)}
        placeholder="Renames the appended sub-container — use a loop variable for per-iteration names"
        aria-label="Alias"
        style={{ flex: 1 }}
      />
    </div>
  </>
)

export default AppendStructStepBody
